<div class="applied-filters-list" *ngIf="(filterPills$ | async)?.length">
  <span class="filters-count"
    >{{ 'Filters' | translate }} ({{ (filterPills$ | async)?.length }}):</span
  >
  <div class="filter-pills-list">
    <app-pencil-pill
      *ngFor="let filter of filterPills$ | async"
      [icon]="filter.isLocked ? 'lock_outline' : ''"
      [iconType]="IconTypes.materialIcon"
      [isRemovable]="!filter.isLocked"
      (remove)="clearFilterPill(filter)"
      class="filter-pill"
    >
      <span class="font-weight-bold">{{ filter.tag }}:</span>
      <span
        [appTooltip]="filter.tag + ': ' + filter.displayText"
        appTooltipPlacement="bottom-center"
        class="display-text"
        >{{ filter.displayText }}</span
      >
    </app-pencil-pill>
  </div>
  <app-pencil-button
    *ngIf="hasClearableFilters$ | async"
    class="pencil-button white small tertiary clear-filters-btn"
    (clickEvent)="clearFilters()"
    >{{ 'Clear' | translate }}
  </app-pencil-button>
</div>
